<template lang="pug">

v-stepper(v-model='e6', vertical='' non-linear=true)
  v-stepper-step(:complete='e6 > 1', step='1' :editable='edit')
    | Creación de usuarios por Token
    small Ingresa la información solicitada
  v-stepper-content(step='1')
    v-card.mb-12#user-data
      template
        v-combobox(v-model='emailsAdm' multiple chips :items='emailsAdm' label='E-mails para visualizaciòn de tokens' :error-messages='errorEmails' :clearable='clearable')
        v-switch(v-model='splitMails' :label='`Difundir Tokens por emails`')
        v-text-field#input-tokens(v-model='numTokens' :error-messages='numsErrors' label='Número de Tokens a Generar' required='') 
        v-autocomplete(v-model='user_inst' :items='user_institutes' :loading='isLoading' :search-input.sync='search'
          hide-no-data='' hide-selected='' item-text='name' item-value='id' label='Usuarios de Institutos' 
          placeholder='Escribe para buscar la cuenta asociada' prepend-icon='mdi-database-search' return-object='')
        v-container
          v-row
            small Asigna exámenes al usuario
          v-row
          v-row
            v-data-table.elevation-1(v-model='selectedExams' :headers='examsHeaders' :items='exams' :single-select='singleSelect' item-key='id' show-select='')
        v-container
          v-row
            small Asigna un grupo provisional al usuario
          v-row
          v-row
            v-data-table.elevation-1(v-model='selectedGroups' :headers='groupsHeaders' :items='groups' :single-select='singleSelect' item-key='id' show-select='')
    v-row(v-if='errorMsg') {{ errorMsg }}            
    v-btn(color='success', @click='registerUsers()' :loading="loading") Registrar
  v-stepper-step(:complete='e6 > 2', step='2' :editable='edit') Tokens Creados
  v-stepper-content(step='2')
    v-card.mb-12
      template#institute-data(v-if='successCreation')
        small Tokens generados ( Esta lista fue envíada a los correos solicitados)
        #tokens-data
            v-data-table.elevation-1(:headers='headers' :items='usersList' item-key='index')

</template>


<script>

  import { config } from '../config.js'

  export default {
    data () {
      return {
        e6: 1,
        clearable: true,
        search: null,
        isLoading: false,
        splitMails: false,
        edit: true,
        loading: false,
        emailsAdm: null,
        errorEmails: '',
        numsErrors:'',
        errorMsg:'',
        numTokens: 1,
        successCreation: true,
        user_inst: '',
        user_institutes: [],
        singleSelect: false,
        selectedExams: [],
        selectedGroups: [],
        exams: [],
        groups: [],
        groupsHeaders: [
          {
            text: 'Grupo',
            align: 'left',
            sortable: true,
            value: 'name'
          },
          { text: 'Descripción', value: 'desc', sortable: false },
          { text: 'Acciones', value: 'action', sortable: false }
        ],
        examsHeaders: [
          {
            text: 'Nombre del Examen',
            align: 'left',
            sortable: false,
            value: 'id'
          },
          { text: 'Descripción', value: 'desc', sortable: false }
        ],
        headers: [ 
            { text: 'Index', value:'index'},
            { text: 'Token', value:'id'}
        ],
        usersList: []
      }
    },
    mounted(){
       this.axios.get(`${config.serviceUri}exams`)
        .then( (response) => {
            console.log('Succes request: ',response.data);
            this.exams = response.data.payload;
            this.$emit("loadingEvent", false);
        })
        .catch( (error) => {
            console.log('Error: ', error);
            this.$emit("loadingEvent", false);
        });

        this.axios.get(`${config.serviceUri}catalogs?catalog=groups`)
        .then( (response) => {
            console.log('Succes request: ',response.data);
            this.groups = response.data.payload.sort(function (a, b) {
                            if (a.name > b.name) {
                              return 1;
                            }
                            if (a.name < b.name) {
                              return -1;
                            }
                            return 0;
                          });
            this.$emit("loadingEvent", false);
        })
        .catch( (error) => {
            console.log('Error: ', error);
            this.$emit("loadingEvent", false);
        });
    },
    watch:{
      usersList(){
        let _this = this;
        console.log(`Usuarios creados ${_this.usersList.length}, es espera: ${_this.numTokens} tokens`)
        if(_this.usersList && _this.usersList.length == _this.numTokens){


            _this.usersList.forEach(user => {

              if( _this.selectedExams.length > 0){
                  let auth_exams = _this.selectedExams.map( e => e.id );
                  let new_auth = {
                    id_user: user.id,
                    exams: auth_exams
                  }

                  this.axios.post(`${config.serviceUri}exams?assign=auth`, new_auth )
                    .then( (response) => {
                        console.log('Succes Realted Exam Created: ',response.data);
                        this.exams.push(response.data)
                        _this.loading = false;
                        this.$emit("loadingEvent", false);
                    })
                    .catch( (error) => {
                        console.log('Error: ', error);
                        _this.loading = false;
                        this.$emit("loadingEvent", false);
                    });
                }else{
                    _this.loading = false;
                    this.$emit("loadingEvent", false);
                } 
            });

            if(_this.emailsAdm && _this.emailsAdm.length > 0){

              if(_this.emailsAdm.length > 0 && _this.splitMails && _this.emailsAdm.length == Number(_this.numTokens)){
                
                let tokensUn = _this.usersList.map( u => u.id);
                debugger;
                _this.emailsAdm.forEach( (e,i) => {
                  let notification = { emails: [e], tokens: [ tokensUn[i] ] };
              
                  this.axios.post(`${config.serviceUri}sendNotification?type=newusers`, notification )
                    .then( (response) => {
                        console.log('The tokens have been sended: ',response.data);
                        _this.loading = false;
                        _this.$emit("loadingEvent", false);
                    })
                    .catch( (error) => {
                        console.log('Error: ', error);
                        _this.loading = false;
                        _this.$emit("loadingEvent", false);
                    });
                })
              }else{
                let notification = { emails: _this.emailsAdm, tokens: _this.usersList.map( u => u.id) };
              
                this.axios.post(`${config.serviceUri}sendNotification?type=newusers`, notification )
                  .then( (response) => {
                      console.log('The tokens have been sended: ',response.data);
                      _this.loading = false;
                      _this.$emit("loadingEvent", false);
                  })
                  .catch( (error) => {
                      console.log('Error: ', error);
                      _this.loading = false;
                      _this.$emit("loadingEvent", false);
                  });
                }

            }
          }
      },
      search(){
        if (this.user_institutes.length > 0) return
        if (this.isLoading) return

        this.axios.get(`${config.serviceUri}users?inst=true`)
        .then( (response) => {
            console.log('Succes request: ',response.data);
            this.user_institutes = response.data.payload;
        })
        .catch( (error) => {
            console.log('Error: ', error);
            this.isLoading = false;
        });

      },
    },
    methods: {
      registerUsers(){
        this.$emit("loadingEvent", true);
        console.log(this.emailsAdm);
        this.loading = true;
        let _this = this;

        if(this.emailsAdm.length > 0 && this.splitMails && this.emailsAdm.length != Number(this.numTokens)){
          this.numsErrors = 'El número de Tokens debe de ser igual a la cantidad de emails en la lista.'
          this.errorMsg = 'ERROR: El número de Tokens debe de ser igual a la cantidad de emails en la lista.'
          this.loading = false;
          return;

        }

        for( var i = 0; i < this.numTokens; i++ ){

          this.axios.post(`${config.serviceUri}users`, {
            name: 'generic',
            groups: _this.selectedGroups,
            id_relInst: _this.user_inst.id
          })
          .then( (response) => {
              console.log('Succes User create: ', response.data);
              let user = {};
              user.name = response.data.payload.name;
              user.id =  response.data.payload.user.id;
              user.index = _this.usersList.length + 1;
              _this.usersList.push(user);
              this.$emit("loadingEvent", false);
          })
          .catch( (error) => {
              console.log('Error: ', error);
              _this.loading = false;
              this.$emit("loadingEvent", false);
          });
        }
        
        setTimeout( () => {
          _this.loading = false;
          _this.e6 = 2;
        }, 100*_this.numTokens)

        
      }
    }
  }
</script>

<style scoped>
  .v-card{
    box-shadow: none;
  }

  .v-btn{
    margin: 0 5px;
  }

  #user-data{
    display: flex;
    flex-wrap: wrap;
  }

  #user-data > .v-input{
    flex: 0 40%;
    width: 100%;
    margin: auto 5px;
  }

  #user-data > .v-input:nth-child(2){
    margin-bottom: 0;
  }


</style>

